// src/components/customer/CategoryCard/CategoryCard.jsx
import React, { useState } from "react";
import "../../../../assets/css/components/customer/cards/categoryCard/CategoryCard.css";

const CategoryCard = ({ category, onClick, delay = 0 }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [imageFailed, setImageFailed] = useState(false);

  return (
    <div
      className="category-card"
      onClick={() => onClick(category.link)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      role="button"
      tabIndex={0}
      onKeyPress={(e) => {
        if (e.key === "Enter") onClick(category.link);
      }}
      style={{ animationDelay: `${delay}s` }}
    >
      {/* Circle Container */}
      <div className={`category-circle ${isHovered ? "hovered" : ""}`}>
        {/* Sirf backend ki image. Na ho ya load fail ho to kuch nahi dikhata (koi retry/loop nahi) */}
        {category.defaultImage && !imageFailed && (
          <img
            src={category.defaultImage}
            alt={category.name}
            className="category-circle-image"
            onError={() => setImageFailed(true)}
          />
        )}

        {/* Overlay - Separate layer */}
        <div className="category-circle-overlay"></div>
      </div>

      {/* Category Name */}
      <h3 className={`category-card-name ${isHovered ? "hovered" : ""}`}>
        {category.name}
      </h3>
    </div>
  );
};

export default CategoryCard;
